import { render, staticRenderFns } from "./PaymentsModal.vue?vue&type=template&id=3b67fb09"
import script from "./PaymentsModal.vue?vue&type=script&lang=js"
export * from "./PaymentsModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentsModal.vue?vue&type=style&index=0&id=3b67fb09&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports